module.exports = __webpack_public_path__ + "media/images/prize__xt-wheelset-88c2e5acf36f751a235dfbab5da5de17.jpg";